'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:NewcustomerCtrl
 * @description
 * # NewcustomerCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('NewcustomerCtrl', function($location, $timeout, $controller, $routeParams, cfpLoadingBar, moment,
    CustomerService, FlashService, postcodeService) {

    var vm = this;
    $controller('BaseController', {
      vm: vm
    });

    vm.registrationData = {
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      dateJoined: '',
      email: '',
      homePhone: '',
      mobile: '',
      address: '',
      town: '',
      postcode: '',
      paymentType: '',
      notes: '',
      homes: []
    };

    vm.formData = {
      sameAddress: false
    };

    var customerId = $routeParams.customerId;
    vm.isExistingCustomer = !!customerId;
    vm.formData.sameAddress = true;
    vm.inprogress = false;
    vm.addresses = [];
    vm.submit = submit;
    vm.autocomplete = autocomplete;

    activate();

    function activate() {
      if (vm.isExistingCustomer) {
        vm.formData.sameAddress = false;
        getCustomer(customerId);
      }
    }

    function submit(valid) {
      var sameAddress = vm.formData.sameAddress;

      if (valid) {
        if (sameAddress) {
          var home = {
            address: vm.registrationData.address,
            town: vm.registrationData.town,
            postcode: vm.registrationData.postcode
          };
          vm.registrationData.homes = [];
          vm.registrationData.homes.push(home);
        }
        vm.inprogress = true;
        cfpLoadingBar.start();

        var saveCustomer = vm.isExistingCustomer ? updateCustomer : createCustomer;

        saveCustomer()
          .finally(function() {
            vm.inprogress = false;
            cfpLoadingBar.complete();
          });
      }
    }

    function createCustomer() {
      return CustomerService.Create(vm.registrationData)
        .then(function(response) {
          FlashService.Success('Customer added');
          var customer = response;
          var homeExists = !!customer.homes.length;

          if (homeExists) {
            $location.path('/homes/edit/' + customer.homes[0].id);
            return;
          }

          $location.path('/customers');
        })
        .catch(function(error) {
          FlashService.Error(error.message);
        });
    }

    function updateCustomer() {
      vm.registrationData.id = customerId;
      return CustomerService.Update(vm.registrationData)
        .then(function(response) {
          FlashService.Success('Customer updated');
          $location.path('/customers/' + customerId);
        }).catch(function(error) {
          FlashService.Error(error.message);
        });
    }

    function getCustomer(id) {
      cfpLoadingBar.start();
      CustomerService.GetById(id).
      then(getCustomerSuccess, responseError)
        .finally(vm.requestComplete.bind(vm));
    }

    function autocomplete(postcode) {
      return postcodeService.autocomplete(postcode)
        .then(function(response) {
          return response;
        });
    }

    function getCustomerSuccess(response) {
      vm.registrationData = response;
      vm.registrationData.dateJoined = moment(vm.registrationData.dateJoined).format('DD/MM/YYYY');
      vm.registrationData.dateOfBirth = moment(vm.registrationData.dateOfBirth).format('DD/MM/YYYY');
      vm.selectedAddress = {
        address: vm.registrationData.address,
        town: vm.registrationData.town
      };
      cfpLoadingBar.complete();
    }

    function responseError(error) {
      $location.path('/newcustomer');
    }

    return vm;
  });
